import { Stack } from '@mui/material';

import { AttachmentCard } from './AttachmentCard';
import type { EpiStagedAttachment } from '../types/epi-chat-types';

export interface AttachmentStripProps {
  attachments: EpiStagedAttachment[];
  onRemove?: (id: string) => void;
  /** Wraps the strip and each card, so a host's existing selectors keep working. */
  testId: string;
  cardTestIdPrefix: string;
}

/** Staged attachments as a wrapping row of cards, above a composer's input. */
export const AttachmentStrip = ({
  attachments,
  onRemove,
  testId,
  cardTestIdPrefix,
}: AttachmentStripProps) => {
  if (attachments.length === 0) return null;
  return (
    <Stack
      direction="row"
      spacing={1}
      data-testid={testId}
      sx={{ padding: 1, paddingBottom: 0, flexWrap: 'wrap', rowGap: 1 }}
    >
      {attachments.map((attachment) => (
        <AttachmentCard
          key={attachment.id}
          filename={attachment.filename}
          size={attachment.size}
          status={attachment.status}
          error={attachment.error}
          onRemove={onRemove ? () => onRemove(attachment.id) : undefined}
          testId={`${cardTestIdPrefix}${attachment.id}`}
        />
      ))}
    </Stack>
  );
};
